import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

interface Props {
  summary: {
    collected_week: number;
    collected_week_count: number;
    collected_month: number;
    collected_month_count: number;
    pending_total: number;
    sales_month_total: number;
    sales_month_count: number;
    sales_change_pct: number;
  };
}

function fmt(n: number): string {
  return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(n);
}

export default function FinanceSummaryCards({ summary }: Props) {
  const cards = [
    {
      title: 'Cobrado Semana',
      value: fmt(summary.collected_week),
      subtitle: `${summary.collected_week_count} cobros`,
      color: '#4caf50',
    },
    {
      title: 'Cobrado Mes',
      value: fmt(summary.collected_month),
      subtitle: `${summary.collected_month_count} cobros`,
      color: '#2196f3',
    },
    {
      title: 'Pendiente Total',
      value: fmt(summary.pending_total),
      subtitle: 'Por cobrar',
      color: '#ff9800',
    },
    {
      title: 'Ventas del Mes',
      value: fmt(summary.sales_month_total),
      subtitle: `${summary.sales_month_count} ventas`,
      color: '#9c27b0',
      changePct: summary.sales_change_pct,
    },
  ];

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' },
        gap: 2,
      }}
    >
      {cards.map((card) => (
        <Card key={card.title} sx={{ position: 'relative', overflow: 'visible' }}>
          <CardContent sx={{ pb: '16px !important' }}>
            <Typography variant="caption" color="text.secondary" fontWeight={500}>
              {card.title}
            </Typography>
            <Typography variant="h6" fontWeight={700} sx={{ color: card.color, mt: 0.5 }}>
              {card.value}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
              <Typography variant="body2" color="text.secondary">
                {card.subtitle}
              </Typography>
              {card.changePct !== undefined && card.changePct !== 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 0.5 }}>
                  {card.changePct > 0 ? (
                    <TrendingUpIcon sx={{ fontSize: 16, color: '#4caf50' }} />
                  ) : (
                    <TrendingDownIcon sx={{ fontSize: 16, color: '#f44336' }} />
                  )}
                  <Typography
                    variant="caption"
                    sx={{ color: card.changePct > 0 ? '#4caf50' : '#f44336', fontWeight: 600 }}
                  >
                    {card.changePct > 0 ? '+' : ''}{card.changePct}%
                  </Typography>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
